var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateclosericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.171429 7.82857C0.285714 7.94286 0.4 8 0.571428 8C0.742857 8 0.857143 7.94286 0.971428 7.82857L4 4.8L7.02857 7.82857C7.14286 7.94286 7.31429 8 7.42857 8C7.54286 8 7.71429 7.94286 7.82857 7.82857C8.05714 7.6 8.05714 7.25714 7.82857 7.02857L4.8 4L7.82857 0.971428C8.05714 0.742857 8.05714 0.4 7.82857 0.171429C7.6 -0.0571429 7.25714 -0.0571429 7.02857 0.171429L4 3.2L0.971428 0.171429C0.742857 -0.0571429 0.4 -0.0571429 0.171429 0.171429C-0.0571429 0.4 -0.0571429 0.742857 0.171429 0.971428L3.2 4L0.171429 7.02857C-0.0571429 7.25714 -0.0571429 7.6 0.171429 7.82857Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateclosericon);
export default __webpack_public_path__ + "static/media/dateclosericon.2a2a5fbdcd77181de549f0dd1412eb39.svg";
export { ForwardRef as ReactComponent };